module.exports = __webpack_public_path__ + "img/PL08220.e11ccea5.png";